// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C9o3","label":"styles_label__viEGH"};